import SVGProps from 'src/components/icons/config/svg-props' //
// Auto-generated file created by svgr-cli source svg-template.cjs
// Run npm run generate-icons to update
// Do not edit
const SvgFileIcon = (props: SVGProps) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={props.size || '1em'}
    height={props.size || '1em'}
    fill="none"
    viewBox="0 0 64 64"
    role="img"
    className="icon"
    {...props}
  >
    <path
      fill="currentColor"
      d="M12.8 9.6A3.2 3.2 0 0 1 16 6.4h20.8a1.6 1.6 0 0 1 1.131.469l12.8 12.8c.3.3.469.707.469 1.131v33.6a3.2 3.2 0 0 1-3.2 3.2H16a3.2 3.2 0 0 1-3.2-3.2zm22.4 0H16v44.8h32v-32h-9.6a3.2 3.2 0 0 1-3.2-3.2zm3.2 2.263V19.2h7.337zM28.8 25.6h-6.4v-3.2h6.4zm12.8 9.6H22.4V32h19.2zm0 9.6H22.4v-3.2h19.2z"
    />
  </svg>
)
export default SvgFileIcon
